/* eslint-disable */ import { attachSingleReferenceComponent, composedOfComponent, memoEval, referenceComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { LynxProfessionalOutdoorIceMachineDrainPump } from '../model/index.js';
export const lynxProfessionalOutdoorIceMachineW15Components = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'LynxProfessionalOutdoorIceMachineW15.$drainPump', true).withEntity('LynxProfessionalOutdoorIceMachineW15'), LynxProfessionalOutdoorIceMachineDrainPump, 'drainPumpId'),
    attachComponent.withComponent(composedOfComponent, '$drainPump', true).withEntity('LynxProfessionalOutdoorIceMachineW15').attach(memoEval((self)=>[
            self.$drainPump?.id ?? null
        ], (id)=>({
            childEntityIds: id === null ? [] : [
                id
            ]
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalOutdoorIceMachineW15').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REFRIGERATOR_LN15ICE',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-outdoor-ice-machine-w-15.js.map